import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  loadingSpinner: {
    marginTop: pxToRem(60),
  },
  rolePermissionGrid: {
    marginTop: `${pxToRem(30)} !important`,
  },
});
